/**
 * Organization 이름에 사용되는 Validation Rule
 *  < > : " / \ | ? * % [ ]
 */
export const namePattern = /^[^<>:"/\\|?*%[\]]+$/;
/**
 * StoreGroup, AccountGroup에 사용되는 Validation Rule
 */
export const groupPattern = /^[^`=\\[\];',/~!@#$%^&*()+|{}:<>?]+$/;
